import React, {useState} from 'react';
import Layout from '../components/layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faClock } from '@fortawesome/free-solid-svg-icons';
import { Form, Col, Button } from 'react-bootstrap';
import axios from 'axios';

const ContactUsPage = () => {
    const [validated, setValidated] = useState(false);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [company, setCompany] = useState('');
    const [comment, setComment] = useState('');
    const [buttonColor, setButtonColor] = useState('primary');
    const [buttonText, setButtonText] = useState('Submit');

    const handleNameChange = (event) => {
        setName(event.target.value);
    };

    const handlePhoneChange = (event) => {
        setPhone(event.target.value);
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleCompanyChange = (event) => {
        setCompany(event.target.value);
    };

    const handleCommentChange = (event) => {
        setComment(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        } else {
            const data = {
                'name': name,
                'phone': phone,
                'email': email,
                'company': company,
                'comment': comment,
            };
            axios({
                method: 'POST',
                url: 'https://us-central1-neovativesite.cloudfunctions.net/sendMail',
                data: data
            }).then(response => {
                if (response.data == "success") {
                    setButtonColor("success");
                    setButtonText("success");
                } else {
                    setButtonColor("danger");
                    setButtonText("try again");
                }
            })
        }
    }

    return (
        <Layout>
            <div className="contact-us">
                <div className="row contact-us__container ">
                    <div className="col-1-of-3">
                        <div className="row u-margin-bottom-small">
                            <h2 className="u-font-weight-500">You may also call us at:</h2>
                            <div className="u-center-text-vertical">
                                <span><FontAwesomeIcon icon={faPhoneSquare} size="4x" color="#2998ff" pull="left" /></span>
                                <h2 className="heading-trinary contact-us__text u-font-weight-500"><a href="tel:+1909-323-0007">+1(909) 323-0007</a></h2>
                            </div>
                        </div>
                        <div className="row">
                            <h2 className="u-font-weight-500">Customer Support Hours:</h2>
                            <div className="u-center-text-vertical">
                                <span><FontAwesomeIcon icon={faClock} size="4x" color="#2998ff" pull="left" /></span>
                                <h2 className="contact-us__text u-font-weight-500">Monday - Friday: 6AM - 6PM PST</h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-2-of-3 contact-us__form-container">
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <Form.Row>
                                <Form.Group as={Col} md="6" controlId="name">
                                    <Form.Label className="contact-us__form-label">Name <span style={{color: "red"}}>*</span></Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        size="lg"
                                        value={name}
                                        onChange={handleNameChange}
                                    />
                                    <Form.Control.Feedback type="invalid">Please enter yout name.</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6">
                                    <Form.Label className="contact-us__form-label">Phone</Form.Label>
                                    <Form.Control
                                        type="text"
                                        size="lg"
                                        value={phone}
                                        onChange={handlePhoneChange}
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} md="6" controlId="email">
                                    <Form.Label className="contact-us__form-label">Email <span style={{color: "red"}}>*</span></Form.Label>
                                    <Form.Control
                                        required
                                        type="email"
                                        size="lg"
                                        value={email}
                                        onChange={handleEmailChange}
                                    />
                                    <Form.Control.Feedback type="invalid">Please enter yout email.</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6">
                                    <Form.Label className="contact-us__form-label">Company</Form.Label>
                                    <Form.Control
                                        type="text"
                                        size="lg"
                                        value={company}
                                        onChange={handleCompanyChange}
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} controlId="comment">
                                    <Form.Label className="contact-us__form-label">Comment <span style={{color: "red"}}>*</span></Form.Label>
                                    <Form.Control
                                        required
                                        as="textarea"
                                        type="text"
                                        size="lg"
                                        style={{height: "200px"}}
                                        value={comment}
                                        onChange={handleCommentChange}
                                    />
                                    <Form.Control.Feedback type="invalid">Please enter yout name.</Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row style={{justifyContent: "flex-end"}} className="u-margin-top-small">
                                <Button type="submit" variant={buttonColor}>{buttonText}</Button>
                            </Form.Row>
                        </Form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ContactUsPage;